// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import {
    createElement,
    Component,
    PropTypes,
    Translate,
    Popover,
} from '@plesk/ui-library';

class ViewSwitcher extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: true,
            popoverVisible: props.isWelcomeMode,
            welcomeMode: props.isWelcomeMode,
        };
    }

    handleTogglePopover = () => {
        if (!this.state.welcomeMode) {
            this.setState({ popoverVisible: !this.state.popoverVisible });
        }
    };

    handleHideSwitcher = () => {
        const { locale } = this.context;
        const { hideSwitcherUrl } = this.props;

        Jsw.messageBox.show({
            type: Jsw.messageBox.TYPE_YESNO,
            subtype: 'toggle',
            text: locale.lmsg('confirmationBoxText'),
            description: locale.lmsg('confirmationBoxDescription'),
            buttonTitles: {
                yes: locale.lmsg('confirmationBoxButtonYes'),
                no: locale.lmsg('confirmationBoxButtonNo'),
            },
            onYesClick: () => {
                this.setState({ visible: false });
                new Ajax.Request(hideSwitcherUrl, { method: 'post' });
            },
        });
    };

    handleChangeView = () => {
        const { changeViewUrl } = this.props;

        new Ajax.Request(changeViewUrl, {
            method: 'post',
            onSuccess(transport) {
                const { redirect } = transport.responseJSON;
                if (redirect) {
                    Jsw.redirect(redirect);
                }
            },
        });
    };

    handleOpenLearnMore = () => {
        if (this.state.welcomeMode) {
            this.disableWelcomeMode();
        }

        Jsw.redirect(this.props.learnMoreUrl);
    };

    handleClosePopover = () => {
        setTimeout(() => {
            this.setState({ popoverVisible: false });

            if (this.state.welcomeMode) {
                this.setState({ welcomeMode: false });
                this.disableWelcomeMode();
            }
        }, 0);
    };

    disableWelcomeMode() {
        new Ajax.Request(this.props.disableWelcomeModeUrl, { method: 'post' });
    }

    renderActionMessage() {
        const { isPowerUserPanel } = this.props;

        const actionMessage = (
            <Translate
                content="actionMessage"
                params={{
                    switchLink: (
                        <a
                            className="js-switch-view"
                            onClick={this.handleChangeView}
                        >
                            <Translate
                                content={this.state.welcomeMode ? 'welcomeSwitchView' : 'switchView'}
                                params={{ view: <Translate content={isPowerUserPanel ? 'serviceProviderView' : 'powerUserView'} /> }}
                            />
                        </a>
                    ),
                    helpLink: (
                        <a onClick={this.handleOpenLearnMore}>
                            <Translate content="learnMore" />
                        </a>
                    ),
                }}
            />
        );

        if (this.state.welcomeMode) {
            return (
                <Translate
                    content={isPowerUserPanel ? 'welcomePowerUser' : 'welcomeProviderView'}
                    params={{ action: actionMessage }}
                />
            );
        }

        return actionMessage;
    }

    renderSwitcherPopover(target) {
        const { isPowerUserPanel, showPowerUserViewWarning } = this.props;

        return (
            <Popover
                visible={this.state.popoverVisible}
                intent="warning"
                target={target}
                title={<Translate content="title" />}
                placement="top-right"
                onClose={this.handleClosePopover}
                canCloseOnOutsideClick={!this.state.welcomeMode}
                canCloseOnEscapePress={!this.state.welcomeMode}
            >
                <Translate
                    content="currentViewMessage"
                    params={{ view: <Translate content={isPowerUserPanel ? 'powerUserView' : 'serviceProviderView'} /> }}
                />
                <p>
                    {this.renderActionMessage()}
                </p>
                {showPowerUserViewWarning && (
                    <span>
                        <i className="icon-attention-tr" />
                        {' '}
                        <Translate content="powerUserViewWarning" />
                    </span>
                )}
            </Popover>
        );
    }

    render() {
        if (!this.state.visible) {
            return null;
        }

        return (
            <div className="view-switcher">
                <span className="close" onClick={this.handleHideSwitcher} />
                <a href="#" onClick={this.handleTogglePopover} >
                    <i className="icon-nav-navigation" />
                    {this.renderSwitcherPopover(<Translate content="title" />)}
                </a>
            </div>
        );
    }
}
ViewSwitcher.propTypes = {
    isPowerUserPanel: PropTypes.bool.isRequired,
    showPowerUserViewWarning: PropTypes.bool.isRequired,
    learnMoreUrl: PropTypes.string.isRequired,
    hideSwitcherUrl: PropTypes.string.isRequired,
    disableWelcomeModeUrl: PropTypes.string,
    changeViewUrl: PropTypes.string.isRequired,
    isWelcomeMode: PropTypes.bool.isRequired,
};
ViewSwitcher.defaultProps = {
    disableWelcomeModeUrl: '',
};
ViewSwitcher.contextTypes = {
    locale: PropTypes.object,
};

export default ViewSwitcher;



// WEBPACK FOOTER //
// ./app/view-switcher/ViewSwitcher.js